import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=2bdd94f8&scoped=true&"
import script from "./Confirmation.vue?vue&type=script&lang=ts&"
export * from "./Confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=2bdd94f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd94f8",
  null
  
)

export default component.exports